<template>
  <div class="review-dialog">
    <el-dialog
      :visible.sync="dialogVisible"
      width="1340"
      top="60px"
      :show-close="true"
      :before-close="handleClose"
      center>
      <div slot="title" class="header">
        <p class="title">{{ reviewObj.panelName }}</p>
        <el-button type="primary" class="btn" :loading="btnLoading" @click="handleSubmit">应用</el-button>
      </div>
      <div class="container">
        <el-image
          :src="reviewObj.panelThumbnail"
          fit="contain"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveScreenApi } from '../fetch'
export default {
  name: 'ReviewDialog',
  components: {
  },
  props: {
    reviewObj: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      dialogVisible: true,
      btnLoading: false,
    }
  },
  created () {},
  methods: {
    handleClose () {
      this.dialogVisible = false
      this.$emit('close')
    },
    async handleSubmit () {
      try {
        this.btnLoading = true
        const panelInfo = await saveScreenApi(this.reviewObj)
        this.$success('操作成功')
        this.dialogVisible = false
        this.$router.push({
          path: `/screen/edit/${panelInfo.panelSn}`,
        })
        this.$emit('close')
      } catch (e) {
        this.$error(e)
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.review-dialog{
  .container{
    width: 100%;
    height: 754px;
    padding: 4% 0 2%;
  }
  ::v-deep .el-dialog__wrapper{
    display: flex;
    top: 0;
    left: 0;
    right: 0;
  }
  ::v-deep .el-dialog{
    position: relative;
    background: none;
    box-shadow: none;
    width: 100%;
    margin: 0 !important;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    .el-image{
      height: 100%;
      width: 100%;
    }
    .el-image__error{
      background: none;
      color: #FFF;
    }
    .el-dialog__header{
      z-index: 2002;
      width: 100%;
      height: 60px;
      line-height: 60px;
      padding: 0 40px 0 30px !important;
      background-color: #000000;
      color: #FFF;
      position: fixed;
      top: 0;
      .header{
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .btn{
          color: #FFF;
          margin-right: 30px;
          font-size: 14px !important;
          height: 34px;
        }
      }
      .el-dialog__headerbtn{
        width: 24px;
        height: 24px;
        background: #E8E8E8;
        border-radius: 50%;
      }
    }
    .el-dialog__body{
      overflow: auto;
      width: 100%
    }
  }

}
</style>
